import React, { ButtonHTMLAttributes, FC, ReactNode } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost' | 'accent';
  className?: string;
}

const Button: FC<ButtonProps> = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseClasses = 'px-6 py-3 font-bold rounded-lg text-white transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-900 shadow-lg transform hover:-translate-y-1';
  
  const variantClasses = {
    primary: 'bg-blue-500 hover:bg-blue-600 focus:ring-blue-500',
    secondary: 'bg-green-500 hover:bg-green-600 focus:ring-green-500',
    ghost: 'bg-transparent border-2 border-slate-500 hover:bg-slate-700 hover:border-slate-700 focus:ring-slate-500',
    accent: 'bg-rose-500 hover:bg-rose-600 focus:ring-rose-500',
  };

  return (
    <button className={`${baseClasses} ${variantClasses[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button;